import type { FilterState } from "@/types";

/**
 * Count filter values that meaningfully narrow the query. timeRange is
 * always set so it doesn\u2019t count as an "active" filter.
 */
export function countActiveFilters(f: Partial<FilterState>): number {
  let n = 0;
  for (const [k, v] of Object.entries(f)) {
    if (k === "timeRange") continue;
    if (v == null || v === "") continue;
    if (Array.isArray(v) && v.length === 0) continue;
    n++;
  }
  return n;
}
